import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_state_pension_viewer = _resolveComponent("state-pension-viewer")!
  const _component_pension_pots_viewer = _resolveComponent("pension-pots-viewer")!
  const _component_final_salary_assets_viewer = _resolveComponent("final-salary-assets-viewer")!
  const _component_savings_viewer = _resolveComponent("savings-viewer")!
  const _component_other_cash_viewer = _resolveComponent("other-cash-viewer")!
  const _component_other_income_viewer = _resolveComponent("other-income-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_state_pension_viewer),
    (_ctx.showPensionPots)
      ? (_openBlock(), _createBlock(_component_pension_pots_viewer, {
          key: 0,
          title: _ctx.pensionPotsViewerTitle,
          onGuaranteedIncomeChangeRequired: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('guaranteed-income-change-required')))
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.showFinalSalary)
      ? (_openBlock(), _createBlock(_component_final_salary_assets_viewer, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.showSavings)
      ? (_openBlock(), _createBlock(_component_savings_viewer, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.showOtherCash)
      ? (_openBlock(), _createBlock(_component_other_cash_viewer, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.showOtherIncome)
      ? (_openBlock(), _createBlock(_component_other_income_viewer, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}